/**
 * Shared Tailwind class for the prototype's text/number inputs (KPI editors,
 * target controls): hairline border, surface fill, brand focus ring. Centralized
 * so the inputs stay visually identical across the report and KPI editors.
 */
export const FORM_INPUT_CLASS =
  'rounded-md border border-line bg-surface px-3 py-1.5 text-sm text-fg outline-none focus:border-brand-active'
